import {IAppState, IFeatureToggles, initialFeatureToggles} from "./Helper";
import {StorageConstants} from "../../util/constants";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {getFeatureToggles, getServerTime} from "./ActionCreators";

const initialValue: IAppState = {
    language: localStorage.getItem(StorageConstants.LANGUAGE) ?? "mk",
    serverTime: null,
    error: false,
    errorCode: undefined,
    featureToggles: initialFeatureToggles,
    spinTheWheelOpen: false,
    appLoading: true
}

const appSlice = createSlice({
    name: SliceNames.APP,
    initialState: initialValue,
    reducers: {
        changeLanguage: (state, action: PayloadAction<string>) => {
            localStorage.setItem(StorageConstants.LANGUAGE, action.payload)
            state.language = action.payload
        },
        setApplicationError: (state, action: PayloadAction<{ isError: boolean, statusCode: number | undefined }>) => {
            state.error = action.payload.isError
            state.errorCode = action.payload.statusCode
        },
        updateServerTime: (state) => {
            state.serverTime = state.serverTime !== null ? state.serverTime + 1000 : null;
        },
        updateRequiredLogin: (state, action: PayloadAction<boolean>) => {
            state.featureToggles = {
                ...state.featureToggles,
                login_required: action.payload,
            }
        },
        toggleSpinTheWheel: (state, action: PayloadAction<boolean>) => {
            state.spinTheWheelOpen = action.payload
        }
    },
    extraReducers: builder => {
        builder.addCase(
            getServerTime.fulfilled, (state, action: PayloadAction<number>) => {
                state.serverTime = action.payload
            })
            .addCase(
                getFeatureToggles.pending, (state) => {
                    state.appLoading = true
                })
            .addCase(
                getFeatureToggles.fulfilled, (state, action: PayloadAction<IFeatureToggles>) => {
                    state.featureToggles = {
                        ...initialFeatureToggles,
                        ...action.payload,
                    }
                    state.appLoading = false
                })
            .addCase(
                getFeatureToggles.rejected, (state) => {
                    state.featureToggles = initialFeatureToggles
                    state.appLoading = false
                })
    }
})

export default appSlice.reducer

export const {
    changeLanguage,
    setApplicationError,
    updateServerTime,
    updateRequiredLogin,
    toggleSpinTheWheel
} = appSlice.actions
